module.exports = __webpack_public_path__ + "web/img/sign-20.580a0049.png";